module.exports = __webpack_public_path__ + "static/media/summer mixed coordinator.568146f9.jpg";